import { ReactElement } from 'react';
import { Routes as AppRoutes, Route, BrowserRouter } from 'react-router-dom';

import { ProtectedRoute } from './ProtectedRoute';
import { PublicRoute } from './PublicRoute';

import { Footer } from '../Footer';
import { Header } from '../Header';
import { LoginScreen } from '../Login/LoginScreen';
import { NoMatch } from '../NoMatch';
import RegisterScreen from '../Register/RegisterScreen';
import TermsAndConditions from '../Register/TermsAndConditions';
import ScrollToTop from '../ScrollToTop';

import NovaCircle from '../../Global/Atomics/NovaCircle';
import Detail from '../../Pages/Detail/Detail';
import Home from '../../Pages/Home/Home';
import Profile from '../../Pages/Profile/Profile';
import Report from '../../Pages/Report/Report';

import { useResponsiveContext } from '../../../contexts/ResponsiveContext';
import { ReportFormProvider } from '../../../contexts/ReportFormContext';

export default function Routes(): ReactElement {
    const [viewMode] = useResponsiveContext();

    const isMobile = viewMode === 'mobile';
    let size = isMobile ? 158 : 220;

    return (
        <BrowserRouter>
            <ScrollToTop />
            <AppRoutes>
                {/* PUBLIC ROUTES */}
                <Route element={<PublicRoute />}>
                    <Route path="/" element={<LoginScreen />} />
                    {/* <Route path="/register" element={<RegisterScreen />} />
                    <Route path="/register/terms" element={<TermsAndConditions />} /> */}
                </Route>

                {/* PRIVATE ROUTES */}
                <Route element={<ProtectedRoute />}>
                    <Route
                        path="/home"
                        element={<><Header bg="green-nova"><NovaCircle size={size} customPosition="top-right" zIndex={1} /></Header><Home /></>}
                    />
                    <Route
                        path="/report"
                        element={<ReportFormProvider><Report /><Footer /></ReportFormProvider>}
                    />
                    <Route
                        path="/detail"
                        element={<Detail />}
                    />
                    <Route
                        path="/profile"
                        element={<Profile />}
                    />
                </Route>

                {/* NO MATCH ROUTES */}
                <Route path="*" element={<NoMatch />} />
            </AppRoutes>
        </BrowserRouter>
    );
}
